import React from "react";
import { toast as t } from "react-toastify";
import FranklyToast from "../components/toasts/FranklyToasts";

const iconByType = {
    success: `${process.env.PUBLIC_URL}/img/toasts/success.png`,
    error: `${process.env.PUBLIC_URL}/img/toasts/error.png`,
    warning: `${process.env.PUBLIC_URL}/img/toasts/warning.png`,
    info: `${process.env.PUBLIC_URL}/img/toasts/info.png`,
    default: `${process.env.PUBLIC_URL}/img/toasts/default.png`,
    inbox: `${process.env.PUBLIC_URL}/img/toasts/mail.png`,
    stamp: `${process.env.PUBLIC_URL}/img/stampcard_stamp.png`
};

const brandSrc = `${process.env.PUBLIC_URL}/img/bus.png`;

function show(type, message, options = {}) {
    const title = options.title || "Frankly Origins";
    const iconSrc = options.iconSrc || iconByType[type || "default"];

    return t(
        ({ toastProps }) => (
            <FranklyToast
                toastId={toastProps.toastId}
                type={type}
                title={title}
                message={String(message)}
                iconSrc={iconSrc}
                brandSrc={brandSrc}
            />
        ),
        {
            ...options,
            icon: false,
            closeButton: false
        }
    );
}

t.success = (message, options) => show("success", message, options);
t.error = (message, options) => show("error", message, options);
t.warning = (message, options) => show("warning", message, options);
t.info = (message, options) => show("info", message, options);

t.frankly = (message, options) => show("default", message, options);
t.inbox = (message, options) => show("inbox", message, options);
t.stamp = (message, options) => show("stamp", message, options);
t.achievement = (message, options) => show("achievement", message, options);

const MAIL_TOAST_ID = 'frankly-mail';
t.mail = (message) => {
    const iconSrc = iconByType.inbox;
    const renderFn = ({ toastProps }) => (
        <FranklyToast
            toastId={toastProps.toastId}
            type="inbox"
            message={String(message)}
            iconSrc={iconSrc}
            brandSrc={brandSrc}
        />
    );
    if (t.isActive(MAIL_TOAST_ID)) {
        t.update(MAIL_TOAST_ID, { render: renderFn, autoClose: 4500 });
    } else {
        t(renderFn, { toastId: MAIL_TOAST_ID, icon: false, closeButton: false });
    }
};

window.addEventListener('unhandledrejection', (event) => {
    if (
        event.reason?.name === 'AbortError' ||
        event.reason?.message?.includes('aborted') ||
        event.reason?.message?.includes('unmounted')
    ) {
        event.preventDefault();
    }
});